import React, {useState} from 'react'
import {Button, message, Modal, Result} from "antd"
import {removeGrouponPlatform} from "../../../api/groupon"
import {usePlatformSettingContext} from "../store/usePlatformSettingContext"
import {DeleteOutlined} from "@ant-design/icons"

const PlatformSettingDelete = ({record}) => {

    const {getPlatformList} = usePlatformSettingContext()

    const [isShow, setIsShow] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false)

    const handleClick = () => {
        setIsShow(true)
    }

    const handleOk = async () => {
        setConfirmLoading(true)
        try {
            await removeGrouponPlatform([record.id]).then(res => {
                if (res.status !== 1) {
                    throw new Error(res.detail)
                }
                message.success('删除成功')
                getPlatformList()
                setIsShow(false)
            })
        } catch (e) {
            message.error(`删除失败:${e.message}`)
        } finally {
            setConfirmLoading(false)
        }
    }

    return (
        <div>
            <Button onClick={handleClick} type={"primary"} danger icon={<DeleteOutlined/>}>删除</Button>
            <Modal
                title={"删除团购平台"}
                open={isShow}
                onCancel={() => setIsShow(false)}
                onOk={handleOk}
                confirmLoading={confirmLoading}
            >
                <Result
                    status={"warning"}
                    subTitle={`确定删除该团购平台: ${record.name} 吗？`}
                >
                </Result>
            </Modal>
        </div>
    )
}

export default PlatformSettingDelete


// WEBPACK FOOTER //
// ./src/containers/PlatformSetting/components/PlatformSettingDelete.js